var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('v-pagination',{staticClass:"custom-pagination",attrs:{"color":"rgba(50, 135, 54, 0.07)","light":"","length":Math.ceil(_vm.total/_vm.perPage),"total-visible":6},on:{"input":function($event){return _vm.$emit('changePage')}},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }